import {
    ChangeDetectorRef,
    Component,
    OnInit,
    inject,
  } from '@angular/core';
  
  import { DatePipe } from '@angular/common';
  import { FormsModule } from '@angular/forms';
  import { Router } from '@angular/router';
  
  import { CampaignService } from '../../services/campaign.service';
  import { PaginationComponent } from '../ui/pagination/pagination.component';
  
  @Component({
    selector: 'app-campaign-list',
    templateUrl: './campaign-list.html',
    styleUrl: './campaign-list.scss',
    imports: [DatePipe, FormsModule, PaginationComponent],
  })
  export class CampaignListComponent implements OnInit {
    private campaignService = inject(CampaignService);
    private cdr = inject(ChangeDetectorRef);
    private router = inject(Router);
  
    campaigns: any[] = [];
    page = 1;
    pageSize = 6;

    get pagedCampaigns(): any[] {
      const start = (this.page - 1) * this.pageSize;
      return this.campaigns.slice(start, start + this.pageSize);
    }

    isLoading = true;
    showCreateForm = false;
    isCreatingCampaign = false;

    newCampaign = {
    responsibleName: '',
    responsibleAge: null as number | null,
    responsibleGender: '',
    street: '',
    neighborhood: '',
    municipality: '',
    email: '',
    phone: '',
    payment: '',
    howDidYouHearAboutAbaq: '',
    socialNetwork: '',
    socialAccount: '',
    recommendedAbaqOnSocialMedia: false,
    petName: '',
    species: 'DOG',
    petGender: '',
    breed: '',
    size: '',
    petAge: null as number | null,
    weight: null as number | null,
    sterilizationDate: '',
    sterilizationLocation: '',
    campaignType: '',
    veterinarian: '',
    comments: '',
    };
  
    ngOnInit(): void {
      this.loadCampaigns();
    }
  
    loadCampaigns(): void {
      this.isLoading = true;
  
      this.campaignService.getAllCampaigns().subscribe({
        next: (response: any) => {
          console.log('🟢 CAMPAÑAS RECIBIDAS:', response);
  
          this.campaigns = response.data.documents;
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
  
        error: (error) => {
          console.error(
            '🔴 ERROR CARGANDO CAMPAÑAS:',
            error,
          );
  
          this.campaigns = [];
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
      });
    }

    openCreateForm(): void {
        this.showCreateForm = true;
      }
      
      closeCreateForm(): void {
        this.showCreateForm = false;
      
        this.newCampaign = {
          responsibleName: '',
          responsibleAge: null,
          responsibleGender: '',
          street: '',
          neighborhood: '',
          municipality: '',
          email: '',
          phone: '',
          payment: '',
          howDidYouHearAboutAbaq: '',
          socialNetwork: '',
          socialAccount: '',
          recommendedAbaqOnSocialMedia: false,
          petName: '',
          species: 'DOG',
          petGender: '',
          breed: '',
          size: '',
          petAge: null,
          weight: null,
          sterilizationDate: '',
          sterilizationLocation: '',
          campaignType: '',
          veterinarian: '',
          comments: '',
        };
      }
      
      createCampaign(): void {
        if (
          !this.newCampaign.responsibleName ||
          !this.newCampaign.petName ||
          !this.newCampaign.species
        ) {
          return;
        }
      
        this.isCreatingCampaign = true;
      
        this.campaignService
          .createCampaign(this.newCampaign)
          .subscribe({
            next: (response: any) => {
              console.log(
                '🟢 CAMPAÑA CREADA:',
                response,
              );
      
              const newCampaign =
                response.data.document;
      
              this.campaigns = [
                newCampaign,
                ...this.campaigns,
              ];
      
              this.isCreatingCampaign = false;
      
              this.closeCreateForm();
      
              this.cdr.detectChanges();
            },
      
            error: (error) => {
              console.error(
                '🔴 ERROR CREANDO CAMPAÑA:',
                error,
              );
      
              this.isCreatingCampaign = false;
      
              this.cdr.detectChanges();
            },
          });
      }
  
    viewCampaign(id: string): void {
      this.router.navigate(['/admin/campaigns', id]);
    }

    copyCampaignFormLink(): void {
        const formUrl =
          `${window.location.origin}/formularios/campanas`;
      
        navigator.clipboard.writeText(formUrl).then(() => {
          alert('Formulario copiado correctamente');
        });
      }
  }